import type { ReactNode } from 'react'
import { formatAngka } from '@/lib/format'

export interface Tren {
  arah: 'naik' | 'turun' | 'datar'
  teks: string
}

export function StatCard({
  label,
  nilai,
  sublabel,
  tren,
  ikon,
  nada = 'netral',
  formatNilai,
}: {
  label: string
  nilai: number | string | null | undefined
  sublabel?: ReactNode
  tren?: Tren
  ikon?: ReactNode
  nada?: 'netral' | 'hijau' | 'merah' | 'emas'
  formatNilai?: (nilai: number | string | null | undefined) => string
}) {
  const warnaNilai =
    nada === 'hijau'
      ? 'text-yayasan-800'
      : nada === 'merah'
        ? 'text-red-700'
        : nada === 'emas'
          ? 'text-emas-700'
          : 'text-netral-900'

  const teksNilai =
    formatNilai !== undefined
      ? formatNilai(nilai)
      : typeof nilai === 'number'
        ? formatAngka(nilai)
        : (nilai ?? '-')

  return (
    <div className="rounded-xl border border-netral-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium tracking-wide text-netral-500 uppercase">{label}</p>
        {ikon ? <span className="text-netral-400">{ikon}</span> : null}
      </div>
      <p className={`angka-tabular mt-2 text-2xl font-semibold break-words ${warnaNilai}`}>{teksNilai}</p>
      <div className="mt-1 flex items-center gap-2">
        {tren ? (
          <span
            className={`text-xs font-medium ${
              tren.arah === 'naik' ? 'text-yayasan-700' : tren.arah === 'turun' ? 'text-red-600' : 'text-netral-500'
            }`}
          >
            {tren.arah === 'naik' ? '▲' : tren.arah === 'turun' ? '▼' : '■'} {tren.teks}
          </span>
        ) : null}
        {sublabel ? <span className="text-xs text-netral-500">{sublabel}</span> : null}
      </div>
    </div>
  )
}
